import React, { memo } from 'react';
import { useMenuQuery } from 'autogen/swagger/all/hooks';
import requestContext from 'modules/requestContext';
import queryStaleTimes from 'setup/react-query/queryStaleTimes';
import SideMenuProvider from '../../shared/context/SideMenuProvider';
import { StyledDrawerView } from '../../shared/styles';
import MenuError from './components/MenuError';
import { MenuHeaderWithMatasLogo } from './components/MenuHeader';
import MenuWithHeader from './components/MenuWithHeader';

const context = requestContext;

const RootMenu = () => {
    const {
        data: menu,
        isLoading,
        isError,
        refetch: retry
    } = useMenuQuery(
        {
            depth: 1,
            display: context.posRequest?.isPosRequest ? 'Pos' : 'Webshop'
        },
        {
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            staleTime: queryStaleTimes.menu
        }
    );

    if (isError && !isLoading) {
        return (
            <StyledDrawerView id="side-menu" position="left">
                <MenuError retryFunction={retry} />
            </StyledDrawerView>
        );
    }

    return (
        <SideMenuProvider>
            <MenuWithHeader
                drawerId="side-menu"
                animate
                menu={menu}
                isLoading={isLoading}
                headerRenderer={(headerProps) => <MenuHeaderWithMatasLogo {...headerProps} />}
            />
        </SideMenuProvider>
    );
};

export default memo(RootMenu);
